import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchPositionSelection, fetchPositionList } from "./../actions/PositionActions";


const PositionSlice = createSlice({
    name: "position",
    initialState: {
        positionSelection: {
            data: [],
            status: 'idle',
            error: "",
            loading: false,          
        },
        positionList: {
            data: [],
            status: 'idle',
            error: "",
            loading: false,
        },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchPositionSelection.pending, (state) => {
          state.positionSelection.status = 'loading';
        })
        .addCase(fetchPositionSelection.fulfilled, (state, action) => {
            state.positionSelection.status = 'idle';
            state.positionSelection.data = action.payload.result;
        })
        .addCase(fetchPositionSelection.rejected, (state, action) => {
          state.positionSelection.status = 'rejected';
          state.positionSelection.error = action.error.message;
        })

        .addCase(fetchPositionList.pending, (state) => {
          state.positionList.status = 'loading';
        })
        .addCase(fetchPositionList.fulfilled, (state, action) => {
            state.positionList.status = 'idle';
            state.positionList.data = action.payload.result;
        })
        .addCase(fetchPositionList.rejected, (state, action) => {
          state.positionList.status = 'rejected';
          state.positionList.error = action.error.message;
        })
    },
});


export default PositionSlice.reducer;
